module.exports = __webpack_public_path__ + "img/42.09882567.png";